module.exports = __webpack_public_path__ + "static/fourth-726c3e8aed702d6f3410ddc52854f45b.jpg";